import { useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { Text } from 'foundations-components/components/Text';
import { Image } from 'foundations-components/transitional/components/Image';
import { VALUE_PROP_ACCENT_STYLES } from './constants';
import ValuePropItem from './ValuePropItem';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ValuePropModalBody = ({
  config,
  activeIndex,
  onActiveIndexChange
}) => {
  const activeValueProp = config.valueProps[activeIndex];
  const [hoveredIndex, setHoveredIndex] = useState(null);
  return /*#__PURE__*/_jsxs(Flex, {
    minBlockSize: "420px",
    children: [/*#__PURE__*/_jsxs(View, {
      flex: "0 0 45%",
      textAlign: "left",
      padding: "600",
      children: [/*#__PURE__*/_jsx(Text, {
        use: "help",
        marginBlockEnd: "800",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: config.summaryKey
        })
      }), /*#__PURE__*/_jsx(Text, {
        as: "h7",
        marginBlockEnd: "800",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "valuePropModals.whatYoullGet"
        })
      }), config.valueProps.map((valueProp, index) => /*#__PURE__*/_jsx(ValuePropItem, {
        valueProp: valueProp,
        index: index,
        isActive: index === activeIndex,
        isHighlighted: index === activeIndex || index === hoveredIndex,
        onClick: () => onActiveIndexChange(index),
        onMouseEnter: () => setHoveredIndex(index),
        onMouseLeave: () => setHoveredIndex(null)
      }, valueProp.titleKey))]
    }), /*#__PURE__*/_jsxs(Flex, {
      flex: "1 1 55%",
      flexDirection: "column",
      backgroundColor: VALUE_PROP_ACCENT_STYLES[activeIndex].iconBackground,
      padding: "400",
      children: [/*#__PURE__*/_jsx(Flex, {
        alignItems: "center",
        justifyContent: "center",
        blockSize: "280px",
        children: /*#__PURE__*/_jsx(Image, {
          src: activeValueProp.image,
          role: "img",
          margin: "0",
          width: "80%"
        })
      }), /*#__PURE__*/_jsx(Text, {
        use: "help",
        marginBlockStart: "200",
        paddingInline: "1000",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: activeValueProp.descriptionKey
        })
      })]
    })]
  });
};
export default ValuePropModalBody;